import * as LucideIcons from "lucide-react";
import { useEffect, useState } from "react";
import { Banners03 } from './banners/Banners03';

interface AnnouncementBarProps {
    showAnnouncement?: boolean;
    announcementText?: string;
    stickyAnnouncement?: boolean;
    style?: string;
    banner03_text?: string;
    banner03_link?: string;
    banner03_icon?: string;
    banner03_direction?: "auto" | "rtl" | "ltr";
    // Standard specific
    announcement_direction?: "auto" | "rtl" | "ltr";
    announcement_icon?: string;
    announcement_link_text?: string;
    announcement_link?: string;
    showCloseButton?: boolean;
}

export function AnnouncementBar({
    showAnnouncement,
    announcementText,
    stickyAnnouncement,
    style = 'standard',
    banner03_text,
    banner03_link,
    banner03_icon,
    banner03_direction,
    announcement_direction = 'auto',
    announcement_icon,
    announcement_link_text,
    announcement_link,
    showCloseButton = false
}: AnnouncementBarProps) {
    const [isDismissed, setIsDismissed] = useState(false);

    useEffect(() => {
        const dismissed = localStorage.getItem('announcement_dismissed');
        if (dismissed === 'true') {
            setIsDismissed(true);
        }
    }, []);

    if (!showAnnouncement || isDismissed) return null;

    const handleDismiss = () => {
        setIsDismissed(true);
        localStorage.setItem('announcement_dismissed', 'true');
    };

    const baseClass = stickyAnnouncement ? 'sticky top-0 z-50 w-full' : 'relative z-50';

    if (style === 'banners-03') {
        return (
            <div className={baseClass}>
                <Banners03
                    text={banner03_text || "أدخل نص الإعلان"}
                    link={banner03_link}
                    icon={banner03_icon}
                    direction={banner03_direction}
                />
                {showCloseButton && (
                    <button
                        onClick={handleDismiss}
                        className="absolute right-4 top-1/2 -translate-y-1/2 rounded-full p-1 hover:bg-black/10 rtl:left-4 rtl:right-auto"
                        aria-label="Dismiss announcement"
                    >
                        <LucideIcons.X className="h-4 w-4" />
                    </button>
                )}
            </div>
        );
    }

    const StandardIcon = announcement_icon ? (LucideIcons as any)[announcement_icon] : null;

    return (
        <div
            className={`bg-secondary px-4 py-2 text-center text-sm font-medium text-secondary-foreground ${baseClass}`}
            dir={announcement_direction === 'auto' ? undefined : announcement_direction}
        >
            <div className="flex items-center justify-center gap-2">
                {StandardIcon && <StandardIcon className="h-4 w-4" />}
                <span>{announcementText}</span>
                {announcement_link_text && (
                    <a href={announcement_link || '#'} className="font-bold underline underline-offset-4 hover:no-underline">
                        {announcement_link_text}
                    </a>
                )}
            </div>
            {showCloseButton && (
                <button
                    onClick={handleDismiss}
                    className="absolute right-4 top-1/2 -translate-y-1/2 rounded-full p-1 hover:bg-primary/10 rtl:left-4 rtl:right-auto"
                    aria-label="Dismiss announcement"
                >
                    <LucideIcons.X className="h-4 w-4" />
                </button>
            )}
        </div>
    );
}
